const _=_=>_&&_.__isYupSchema__;export{_ as default};
//# sourceMappingURL=isSchema.js.map
